/**
 * Patient-facing call copy aligned with Figma DF--Virtual-Nurse-IP (incoming / missed / connecting).
 */

export interface IncomingCallHeadlineParams {
  nurseName?: string
  /** When true, show "Your nurse is calling" (Figma generic variant). */
  useGenericNurseLabel?: boolean
}

/** e.g. "Maria Mendez, RN is calling" | "Your nurse is calling" */
export function incomingCallHeadline(params: IncomingCallHeadlineParams): string {
  const { nurseName, useGenericNurseLabel } = params
  if (useGenericNurseLabel) {
    return 'Your nurse is calling'
  }
  if (!nurseName?.trim()) {
    return 'Your nurse is calling'
  }
  const n = nurseName.trim()
  if (/\bRN\b/i.test(n)) return `${n} is calling`
  return `${n}, RN is calling`
}

/**
 * Subtitle under the headline — full sentence with terminal punctuation.
 * API may send "About your admission" or "About your admission."; we normalize.
 */
export function incomingPurposeLine(callPurpose?: string): string {
  const raw = callPurpose?.trim()
  if (!raw) return 'About your care.'
  if (/[.!?]$/.test(raw)) return raw
  return `${raw}.`
}

/**
 * Missed-call body: "Let us know when you're available to talk about your admission."
 */
export function missedCallAvailabilityLine(callPurpose?: string): string {
  const line = incomingPurposeLine(callPurpose)
  const clause = line.replace(/\.$/, '').trim().toLowerCase()
  return `Let us know when you're available to talk ${clause}.`
}

export function connectingCareTeamHeadline(): string {
  return 'Someone from your care team is calling'
}

/** Breakthrough / auto-connect hero (Figma auto-connect row). */
export function breakthroughPrimaryLine(): string {
  return "We're connecting you now"
}

export function breakthroughSecondaryLine(): string {
  return 'Please wait while we set up your video call.'
}
